import { render } from "./Index.vue?vue&type=template&id=5914728f"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render

export default script